import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET USER TYPES
// ===================================================================================
export const userTypesLoading = () => {
	return {
		type: "USER_TYPE_IS_LOADING"
	};
};

export const userTypesError = err => {
	return {
		type: "USER_TYPE_HAS_ERROR",
		err
	};
};

export const userTypesSuccess = data => {
	return {
		type: "USER_TYPE_SUCCESS",
		data
	};
};

export function getUserTypes() {
	return dispatch => {
		dispatch(userTypesLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "user-types", {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(userTypesError(response.data.errors));
				} else {
					dispatch(userTypesSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(userTypesError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/userTypes.js